
const digest = '91daa79d3d88e06bc62736abd14f87d963837df8fbf4f1c8cbabf9889ef0d509';
const classes = {"wrapper":"_wrapper_pwpbf_1","title":"_title_pwpbf_8","alignTitle":"_alignTitle_pwpbf_12","value":"_value_pwpbf_15","extra":"_extra_pwpbf_19","iconWrapper":"_iconWrapper_pwpbf_24"};
const css = `._wrapper_pwpbf_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 15px;
}
._wrapper_pwpbf_1 ._title_pwpbf_8 {
  font-size: 14px;
  color: #9ea0a5;
}
._wrapper_pwpbf_1 ._alignTitle_pwpbf_12 {
  min-width: 260px;
}
._wrapper_pwpbf_1 ._value_pwpbf_15 {
  font-size: 14px;
  color: #3e3f42;
}
._wrapper_pwpbf_1 ._extra_pwpbf_19 {
  font-size: 12px;
  color: #ccc;
  font-weight: 500;
}
._wrapper_pwpbf_1 ._iconWrapper_pwpbf_24 {
  display: flex;
}
._wrapper_pwpbf_1 ._iconWrapper_pwpbf_24 img {
  width: 18px;
  height: 18px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  